module.exports = __webpack_public_path__ + "img/siber_kume.ad6fed1a.png";